<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="info">
    <span class="title">Planning a<br>Group Event?</span>
    <span class="text">Reserve 6+ lanes or the entire centre (up to 120 guests)!</span>
    <div class="items">
      <div class="item">🎳 12 lanes</div>
      <div class="item">🕹 Arcade</div>
      <div class="item">🍔 Food & Drinks</div>
      <div class="item">🏖 Patio</div>
      <div class="item">🐴 Horseshoes</div>
    </div>
  </div>
  <div class="instruction">
    <div class="email">
      <span class="label">Email</span>
      <div class="address">tammy&#64;georgianbowl.com</div>
      <span class="sub">to get started</span>
    </div>
    <div class="include">
      <span class="label">Include:</span>
      <div class="details">
        <div class="detail">Group Name</div>
        <div class="detail">Event type</div>
        <div class="detail">Contact Info</div>
        <div class="detail">Date/Time</div>
      </div>
    </div>
    <div class="description">
      Let’s make your event<br>
      <span class="green">unforgettable</span> at Georgian Bowl!
    </div>
  </div>
</div>
